import React from 'react';
import Card from '../../ui/Card';
import { TrendingUpIcon, DownloadIcon, EyeIcon, MousePointerClickIcon } from 'lucide-react';
const ContentPerformance: React.FC = () => {
  const metrics = [{
    title: 'Website Visits',
    value: '45,280',
    change: '+12.5%',
    icon: <EyeIcon size={20} data-id="element-7022" />,
    color: 'text-blue-600 bg-blue-50'
  }, {
    title: 'Resource Downloads',
    value: '3,842',
    change: '+8.2%',
    icon: <DownloadIcon size={20} data-id="element-7023" />,
    color: 'text-green-600 bg-green-50'
  }, {
    title: 'Engagement Score',
    value: '78/100',
    change: '+5 pts',
    icon: <MousePointerClickIcon size={20} data-id="element-7024" />,
    color: 'text-purple-600 bg-purple-50'
  }];
  const topContent = [{
    title: 'EV Battery Technology Whitepaper',
    downloads: 842,
    engagement: 92
  }, {
    title: 'LED Lighting Product Catalog',
    downloads: 725,
    engagement: 88
  }, {
    title: 'ADAS Integration Guide',
    downloads: 618,
    engagement: 85
  }, {
    title: 'Aftermarket Parts Guide',
    downloads: 495,
    engagement: 78
  }];
  return <Card className="p-6" data-id="element-7025">
      <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-7026">
        Content Performance
      </h3>
      <div className="grid grid-cols-3 gap-4 mb-6" data-id="element-7027">
        {metrics.map((metric, index) => <div key={index} className={`p-4 rounded-lg ${metric.color.split(' ')[1]}`} data-id="element-7028">
            <div className={`${metric.color.split(' ')[0]} mb-2`} data-id="element-7029">
              {metric.icon}
            </div>
            <div className="text-2xl font-bold text-gray-800" data-id="element-7030">
              {metric.value}
            </div>
            <div className="text-xs text-gray-600 mt-1" data-id="element-7031">{metric.title}</div>
            <div className="text-xs text-green-600 mt-1 flex items-center" data-id="element-7032">
              <TrendingUpIcon size={12} className="mr-1" data-id="element-7033" />
              {metric.change}
            </div>
          </div>)}
      </div>
      <div className="border-t border-gray-200 pt-4" data-id="element-7034">
        <h4 className="text-sm font-semibold text-gray-700 mb-3" data-id="element-7035">
          Top Performing Content
        </h4>
        <div className="space-y-3" data-id="element-7036">
          {topContent.map((content, index) => <div key={index} className="flex items-center justify-between text-sm" data-id="element-7037">
              <span className="text-gray-700 flex-1" data-id="element-7038">{content.title}</span>
              <div className="flex items-center space-x-4" data-id="element-7039">
                <span className="text-gray-600" data-id="element-7040">{content.downloads} DLs</span>
                <span className="text-gray-600" data-id="element-7041">{content.engagement}%</span>
              </div>
            </div>)}
        </div>
      </div>
    </Card>;
};
export default ContentPerformance;